export var MetricTypes;
(function (MetricTypes) {
    MetricTypes["IS_EMPTY"] = "IS_EMPTY";
    MetricTypes["IS_NOT_EMPTY"] = "IS_NOT_EMPTY";
    MetricTypes["IS_NOT_EMPTY_PERCENTAGE"] = "IS_NOT_EMPTY_PERCENTAGE";
    MetricTypes["IS_EMPTY_PERCENTAGE"] = "IS_EMPTY_PERCENTAGE";
    MetricTypes["SUM"] = "SUM";
    MetricTypes["AVG"] = "AVG";
    MetricTypes["MAX"] = "MAX";
    MetricTypes["MIN"] = "MIN";
    MetricTypes["RANGE"] = "RANGE";
    MetricTypes["DATE_RANGE"] = "DATE_RANGE";
    MetricTypes["DATE_MIN"] = "DATE_MIN";
    MetricTypes["DATE_MAX"] = "DATE_MAX";
    MetricTypes["COUNT"] = "COUNT";
    MetricTypes["COUNT_PERCENTAGE"] = "COUNT_PERCENTAGE";
})(MetricTypes || (MetricTypes = {}));
